import { Node } from 'slate';

export function serialize(nodes) {
  if (Array.isArray(nodes)) {
    const result = nodes.map((n) => Node.string(n)).join('\n');
    return result;
  } else {
    return nodes;
  }
}
